import React from "react";
import { DashboardSidebar } from "../../layouts";

function DashboardLayout({ children }) {
  return (
    <div className="dashboard-wrap">
      <DashboardSidebar />
      <div className="dashboard-screen">{children}</div>
    </div>
  );
}

export default DashboardLayout;
